import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Modal } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Azioni riga tabella admin con modifica, eliminazione e modale di conferma.
 * @param {Object} props - Proprietà del componente
 * @param {string|number} props.id - Identificativo della riga
 * @param {string} props.editPath - Percorso base per la modifica (es. `/admin/users/`)
 * @param {Function} props.onDelete - Callback invocata alla conferma dell'eliminazione
 * @param {string} props.deleteHeader - Titolo della modale di conferma
 * @param {string} props.deleteMessage - Messaggio di conferma eliminazione
 * @returns {import('react').JSX.Element} Gruppo di azioni per riga tabella
 */
export const AdminTableActions = ({ id, editPath, onDelete, deleteHeader, deleteMessage }) => {
  const navigate = useNavigate()
  const [modalVisible, setModalVisible] = useState(false)

  /**
   * Esegue l'eliminazione e chiude sempre la modale al termine dell'operazione.
   */
  const handleConfirmDelete = async () => {
    try {
      await onDelete(id)
    } finally {
      setModalVisible(false)
    }
  }

  return (
    <div className="admin-table-actions">
      <Modal
        visible={modalVisible}
        header={deleteHeader}
        className="nora-dialog nora-dialog--danger"
        contentStyle={{ padding: 0 }}
        style={{ width: 'min(440px, 92vw)' }}
        onHide={() => setModalVisible(false)}
      >
        <div className="nora-dialog__body--compact">
          <div className="nora-dialog__confirm">
            <span className="nora-dialog__icon" aria-hidden="true">
              <i className="pi pi-exclamation-triangle" style={{ fontSize: 18 }} />
            </span>
            <p className="nora-dialog__message">{deleteMessage}</p>
          </div>
        </div>
        <div className="nora-dialog__body nora-dialog__footer">
          <button type="button" className="nbtn" onClick={() => setModalVisible(false)}>
            {t.annulla}
          </button>
          <button type="button" className="nbtn nbtn--danger" onClick={handleConfirmDelete}>
            {t.conferma}
          </button>
        </div>
      </Modal>
      <button
        type="button"
        className="naction-btn"
        title={t.modifica}
        onClick={() => navigate(editPath + id)}
      >
        <i className="pi pi-pencil" style={{ fontSize: 15 }} />
      </button>
      <button
        type="button"
        className="naction-btn"
        title={t.elimina}
        onClick={() => setModalVisible(true)}
      >
        <i className="pi pi-trash" style={{ fontSize: 15 }} />
      </button>
    </div>
  )
}

/**
 * Pulsanti azione standard per editor admin (indietro + salva).
 * @param {Object} props - Proprietà del componente
 * @param {Function} props.onBack - Callback per tornare indietro
 * @param {Function} props.onSave - Callback per salvare
 * @param {string} props.backLabel - Etichetta pulsante indietro
 * @param {string} props.saveLabel - Etichetta pulsante salva
 * @returns {import('react').JSX.Element} Gruppo pulsanti editor
 */
export const AdminEditorActions = ({ onBack, onSave, backLabel, saveLabel }) => (
  <>
    <button type="button" className="nbtn" onClick={onBack}>
      <i className="pi pi-arrow-left" style={{ fontSize: 14 }} />
      {backLabel}
    </button>
    <button type="button" className="nbtn nbtn--primary" onClick={onSave}>
      <i className="pi pi-check" style={{ fontSize: 14 }} />
      {saveLabel}
    </button>
  </>
)
